import { getLocalizedTimeFrame } from '../shared/utils/date';
import { isNil } from './commonUtil';

export const DEFAULT_TIME_FRAME = {
  startTime: '08:00',
  endTime: '17:00',
  timeZone: 'America/Los_Angeles',
};

/**
 * @typedef {Object} TimeFrame
 * @property {string} startTime
 * @property {string} endTime
 * @property {string} timeZone
 */

/**
 * Normalize the availability time period
 *
 * @param {string} locale - user locale
 * @param {string} availability - availability string
 * @param {TimeFrame} timeFrame - the start and end time with the time zone
 * @return {string} - string for availability
 */
const getAvailability = (locale, availability, timeFrame) => {
  if (isNil(timeFrame) || isNil(locale)) return '';
  const time = getLocalizedTimeFrame(timeFrame, locale);
  let text = availability.replace('##START_TIME##', time.startTime);
  text = text.replace('##END_TIME##', time.endTime);
  text = text.replace('##TIME_ZONE##', time.timeZone);
  return text;
};

export default getAvailability;
